import * as yup from 'yup';

export const changeEnvForm = yup.object().shape({
  REACT_APP_ADMIN_API_URL: yup.string().required().default(''),
  REACT_APP_DEFAULT_CLIENT: yup.string().required().default('palmlaneqa'),
});
